// @ts-nocheck
/* eslint-disable */
// Since this file contains wild function, we disable Eslint and Typecheck

'use client'

import React, { ComponentType, useEffect } from 'react'
import { widgetsCdn } from '@/components/widgets/widgetsCdn'
import { isProductionEnv } from 'shared/envHelpers'
import { ParsedUrlQuery } from 'querystring'

type HomePageGameWidgetProps = {
  htmlContainerId: string
  widgetName: string
  teamId?: string
  clubId?: string
  tournamentId?: string
  organizationId?: string
  tag?: string
  query?: ParsedUrlQuery
}
const Widget: ComponentType<HomePageGameWidgetProps> = ({
  htmlContainerId,
  widgetName,
  teamId,
  clubId,
  tournamentId,
  organizationId,
  tag,
  query
}) => {
  const cdn = isProductionEnv() ? widgetsCdn.production : widgetsCdn.staging
  //const cdn = isProductionEnv() ? widgetsCdn.production : widgetsCdn.local // for local server
  const env = isProductionEnv() ? 'production' : 'staging'
  useEffect(() => {
    ;(function (e, t, n, r, i, s, o) {
      ;(e[i] =
        e[i] ||
        function () {
          ;(e[i].q = e[i].q || []).push(arguments)
        }),
        (e[i].l = 1 * new Date())
      ;(s = t.createElement(n)), (o = t.getElementsByTagName(n)[0])
      s.async = 1
      s.src = r
      o.parentNode.insertBefore(s, o)
    })(window, document, 'script', cdn, '_hb')
    _hb({
      widget: widgetName,
      teamId: teamId,
      clubId: clubId,
      tournamentId: tournamentId,
      organizationId: organizationId,
      tag: tag,
      container: htmlContainerId,
      env,
      season: query?.season,
      phase: query?.phase
    })
  })
  return <div id={htmlContainerId} />
}

export default Widget
